export default __webpack_public_path__ + "static/media/General's Helm of the Golden Sun.7e244fa5.jpg";